import React, { useEffect, useState } from "react";
import Dialog from ".";
import { IconLoading } from "../../assets/icons";

const DialogReferralCode = ({ open, onClose, onConfirm, initialCode = "" }) => {
  const [referral, setReferral] = useState(initialCode);

  useEffect(() => {
    if (!open) {
      setReferral("");
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      width="420px"
      className="!bg-white !ring-1 !ring-[#D9D9D9]"
    >
      <div className="text-center">
        <h3 className="text-xl font-semibold mb-2">Have a Referral Code?</h3>
        <p className="text-sm text-gray-500 mb-5">
          Enter your referral code if you have one, or skip to continue.
        </p>

        <input
          type="text"
          value={referral}
          onChange={(e) => setReferral(e.target.value)}
          placeholder="Referral code (optional)"
          className="w-full mb-4"
        />

        <div className="flex w-full gap-3">
          <button
            onClick={() => onConfirm(referral)}
            className="flex-1 !bg-[#007A78] !py-3 font-semibold text-white rounded-lg"
          >
            Continue
          </button>

          <button
            onClick={() => onConfirm("")}
            className="flex-1  text-[#007A78] !bg-transparent ring-1 ring-[#007A78] !py-3 font-semibold rounded-lg"
          >
            Skip
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogReferralCode;
